/* =====================================================================
   HBSKN — Motion package
   - Custom cursor (subtle, brand-fit)
   - Magnetic CTAs (any element with [data-hb-magnetic])
   - Generic scroll reveal for [data-hb-reveal] elements
   All features respect prefers-reduced-motion.
   ===================================================================== */
(function () {
  'use strict';

  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var TOUCH = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  var EZ = function (t) { return 1 - Math.pow(1 - t, 3); };

  /* Safari ha bug di rendering con mix-blend-mode + custom cursor → fallback nativo */
  var IS_SAFARI = /^((?!chrome|android).)*safari/i.test(navigator.userAgent) && !/CriOS|FxiOS|EdgiOS/.test(navigator.userAgent);
  if (IS_SAFARI) document.documentElement.classList.add('hb-no-custom-cursor');

  /* ---------- 1) Custom cursor ---------- */
  function initCursor() {
    if (REDUCED || TOUCH || window.innerWidth < 1024) return;
    if (IS_SAFARI) return;  // skip su Safari: usa cursor nativo

    var dot = document.createElement('div');
    dot.className = 'hb-cursor is-visible';  // visible da subito (no gating su mouseenter inaffidabile)
    dot.setAttribute('aria-hidden', 'true');
    dot.innerHTML = '<span class="hb-cursor__dot"></span><span class="hb-cursor__ring"></span>';
    document.body.appendChild(dot);

    var x = window.innerWidth / 2, y = window.innerHeight / 2;
    var rx = x, ry = y;
    var raf = null;
    var hover = false;

    function tick() {
      raf = null;
      rx += (x - rx) * 0.22;
      ry += (y - ry) * 0.22;
      dot.style.transform = 'translate3d(' + rx + 'px,' + ry + 'px,0)';
      if (Math.abs(x - rx) > 0.1 || Math.abs(y - ry) > 0.1) raf = requestAnimationFrame(tick);
    }

    document.addEventListener('mousemove', function (e) {
      x = e.clientX; y = e.clientY;
      if (!dot.classList.contains('is-visible')) dot.classList.add('is-visible');
      if (!raf) raf = requestAnimationFrame(tick);
    }, { passive: true });

    document.addEventListener('mouseleave', function () { dot.classList.remove('is-visible'); }, { passive: true });
    document.addEventListener('mouseenter', function () { dot.classList.add('is-visible'); }, { passive: true });

    var hoverSel = 'a, button, [role="button"], input[type="submit"], .hb-hero__btn, .hb-mn__btn, .hb-pg__card, .hb-rt__card, .hb-mf__cta, .hb-er__cta, .hb-nl__btn, [data-hb-magnetic]';
    document.addEventListener('mouseover', function (e) {
      if (e.target.closest && e.target.closest(hoverSel)) dot.classList.add('is-hover');
    }, true);
    document.addEventListener('mouseout', function (e) {
      if (e.target.closest && e.target.closest(hoverSel)) dot.classList.remove('is-hover');
    }, true);
  }

  /* ---------- 2) Magnetic CTAs ---------- */
  function initMagnetic() {
    if (REDUCED || TOUCH) return;
    var els = document.querySelectorAll('[data-hb-magnetic], .hb-hero__btn, .hb-mn__btn');
    var STRENGTH = 0.28;
    els.forEach(function (el) {
      var raf = null, tx = 0, ty = 0, x = 0, y = 0;
      function tick() {
        raf = null;
        x += (tx - x) * 0.18;
        y += (ty - y) * 0.18;
        el.style.transform = 'translate3d(' + x.toFixed(2) + 'px,' + y.toFixed(2) + 'px,0)';
        if (Math.abs(tx - x) > 0.1 || Math.abs(ty - y) > 0.1) raf = requestAnimationFrame(tick);
      }
      el.addEventListener('mousemove', function (e) {
        var r = el.getBoundingClientRect();
        tx = (e.clientX - r.left - r.width / 2) * STRENGTH;
        ty = (e.clientY - r.top - r.height / 2) * STRENGTH;
        if (!raf) raf = requestAnimationFrame(tick);
      });
      el.addEventListener('mouseleave', function () {
        tx = 0; ty = 0;
        if (!raf) raf = requestAnimationFrame(tick);
      });
    });
  }

  /* ---------- 3) Generic scroll reveal ---------- */
  function initReveal() {
    var els = document.querySelectorAll('[data-hb-reveal]');
    if (!els.length) return;
    if (REDUCED || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    initCursor();
    initMagnetic();
    initReveal();
  });
})();
